import { useCrudActions } from '@/common/view/useCrudActions';
import { googleService } from '@/services/google';
import useVuelidate from '@vuelidate/core';
import { required, url } from '@vuelidate/validators';
import { reactive } from 'vue';

export default function () {
    const crudAction = useCrudActions();

    const model = reactive({
        isNew: true,
        store: 4,
        clientId: '',
        clientSecret: '',
        redirectUri: '',
        storeOptions: [{ value: 4, label: 'Website' }]
    });

    const validations = {
        store: { required },
        clientId: { required },
        clientSecret: { required },
        redirectUri: { required, url }
    };

    const v$ = useVuelidate(validations, model);

    const fetch = crudAction.executeAction({
        request: () => googleService.linkedApp.get(model.store),
        onSuccess: ({ data }) => {
            model.isNew = false;
            model.store = data.store;
            model.clientId = data.clientId;
            model.clientSecret = data.clientSecret;
            model.redirectUri = data.redirectUri;
        },
        onError: () => {
            model.isNew = true;
            model.store = 4;
            model.clientId = '';
            model.clientSecret = '';
            model.redirectUri = '';
        }
    });

    const actions = {
        update: crudAction.excuteAndNotify({
            validator: v$,
            request: () =>
                googleService.linkedApp.update(model.store, model.clientId, model.clientSecret, model.redirectUri),
            onSuccess: fetch
        }),
        remove: crudAction.confirmAndRemove({
            request: () => googleService.linkedApp.remove(model.store),
            onSuccess: fetch
        })
    };

    return { model, v$, fetch, actions };
}
